import Tooltip from "@elsa-zku/lib/components/Tooltip/Tooltip";
import * as React from 'react';
import styles from 'src/style/common.scss';

export const NocalcIcon = () => (
  <Tooltip content="Только поквартирные отчеты (расчеты ведутся в другой программе)">
    <span>
      <img src={require('src/icons/no-calc.svg')} className={styles.nocalcIcon} />
    </span>
  </Tooltip>
)

export const formatBuildingAddress = (building: { address: string, is_archived?: boolean, only_for_reports?: boolean, settings?: { only_for_reports?: boolean } }) => {
  if (!building) return '';
  return (
    <>
      {(building.only_for_reports || building.settings?.only_for_reports) && <NocalcIcon />}
      {building.is_archived && '(Архив) '}
      {building.address}
    </>
  );
}